/**
 * 自提核销码规范化：与 C 端 QR payload 对齐（纯 8 位数字）。
 * 兼容扫码结果夹带空格/前后缀时提取连续 8 位。
 */
export function normalizePickUpVerifyCode(raw: string | null | undefined): string {
  if (raw == null) return ''
  const text = String(raw).trim()
  if (!text) return ''
  if (/^\d{8}$/.test(text)) return text
  const exact = text.match(/(?:^|[^\d])(\d{8})(?:$|[^\d])/)
  if (exact?.[1]) return exact[1]
  const any = text.match(/\d{8}/)
  return any?.[0] ?? text.replace(/\s+/g, '')
}
